// extracted by mini-css-extract-plugin
export var autoExpand = "_2k-8";
export var container = "_2k-7";
export var containerWidth = "_2k-5";
export var disabled = "_2k-2";
export var error = "_2k-3";
export var fullWidth = "_2k-6";
export var inputWrapper = "_2k-0";
export var small = "_2k-1";
export var textarea = "_2k-4";